import { displayToast } from '../toastify/toastify';
import { handleAddToBagSuccess } from './buy-grid';
import { gaTracking } from '../event/event';

export const tableGridSetup = () => {
    const tableGrid = document.querySelector<HTMLFormElement>('.buy-grid--table');
    if (tableGrid) {
        const qtyButtons = tableGrid.querySelectorAll<HTMLButtonElement>('.qty-controls button');
        qtyButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new Event('change', { bubbles: true });
                const qtyInput = button.parentElement.querySelector<HTMLInputElement>('input');
                let currentValue = parseInt(qtyInput.value);
                const maxValue = parseInt(qtyInput.getAttribute('max'));                

                if (button.classList.contains('increase')) {
                    if (currentValue >= maxValue) {
                        alert(`Maximum value of ${maxValue} reached.`);
                        return;
                    }
                    qtyInput.value = (currentValue + 1).toString();
                    qtyInput.dispatchEvent(event);
                } else if (button.classList.contains('decrease') && currentValue > 0)
                    qtyInput.value = (currentValue - 1).toString();
                qtyInput.dispatchEvent(event);
            });

        });

        const qtyInputs = tableGrid.querySelectorAll<HTMLInputElement>('.qty-controls input');
        qtyInputs.forEach(input => {
            input.addEventListener('change', () => {

                const addToBagBtn = tableGrid.querySelector<HTMLButtonElement>('.js-add-to-bag');
                const hasQtyAboveZero = Array.from(qtyInputs).some(input => parseInt(input.value) > 0);
                const qtyBelowZero = Array.from(qtyInputs).some(input => parseInt(input.value) < 0);                
                const maxValue = parseInt(input.getAttribute('max'));

                if (parseInt(input.value) > maxValue) {
                    alert(`There are only ${maxValue} of this item in stock.`);
                    input.value = maxValue.toString();
                }

                if (qtyBelowZero) {
                    alert('Only values above 0 allowed.')
                    input.value = "0";
                }

                if (hasQtyAboveZero) {
                    addToBagBtn.classList.remove('disabled');
                    addToBagBtn.innerText = 'Add screws to basket';
                } else {
                    addToBagBtn.innerText = 'Select screws';
                    addToBagBtn.classList.add('disabled');
                }
            });
        });
    }
}

export const handleTableAddToBag = (buyGrid: HTMLFormElement) => {
    const formData = new FormData(buyGrid);
    const addToBagBtn = buyGrid.querySelector<HTMLButtonElement>('.js-add-to-bag');
    fetch("/basket/api/addmany", {
        method: 'POST',
        body: formData
    }).then(r => {
        return r.json();
    }).then(data => {
        const isSuccessful = data.success || data.message.includes('added to bag');
        if (isSuccessful) handleAddToBagSuccess(buyGrid, data, data.message.match(/\d+/)[0]);
        if (data.errors.length > 0) {
            setTimeout(() => {
                let timeout = 0;
                data.errors.forEach((error) => {
                    setTimeout(() => {
                        displayToast(error, {
                            className: 'toastify-center swatch-danger rounded px-lg-5',
                            duration: 1500
                        });
                    }, timeout);
                    timeout += 2000;
                });
            }, isSuccessful ? 2000 : 0); 
        };            

        addToBagBtn.innerText = 'Select Screws';

        const qtyInputs = buyGrid.querySelectorAll<HTMLInputElement>('.qty-controls input');
        qtyInputs.forEach(input => { input.value = "0"; });

        if (isSuccessful) buildGaTracking(data);

    });
}

function buildGaTracking(obj) {
    const currentUrl = new URL(window.location.href);
    const searchTerm = currentUrl.searchParams.get('search_term');

    const items = obj.data.map(product => {
        const item: any = {
            item_id: product.productId,
            item_name: product.stockTitle,
            quantity: product.quantity,
            price: product.itemPrice,
            item_brand: "No brand data available",
            item_category: "No category data available"
        };

        // add search_term to every item if present
        if (searchTerm) {
            item.search_term = searchTerm;
        }

        return item;
    });

    const totalValue = obj.data.reduce((sum, product) => {
        return sum + (product.itemPrice * product.quantity);
    }, 0);

    gaTracking("add_to_cart", false, {
        currency: "GBP",
        value: totalValue,
        items: items,
    });
}